export const requests = {
  en: {
    kindBug: "Report a problem",
    kindBugHint: "Something in the system did not work. It reaches the administrator.",
    bugPlaceholder: "What happened? Write it however you like.",
    bugCaptured: "The page you were on, who you are and the time are attached automatically — you do not need to describe them.",
    bugWhatHappened: "What happened?",
    bugWhatHappenedHint: "What you were doing, and what the system did instead. Anything you can remember helps.",
    bugWhereLabel: "Where it happened",
    bugWhereNote: "Taken from the screen you were on when you opened this. It is sent with the report so the problem can be found.",
    bugStatusOpen: "Open",
    bugStatusFixed: "Fixed",
    bugStatusWontFix: "Not a fault",
    bugStatusWithdrawn: "Withdrawn",
    kindCertificate: "Salary certificate",
    kindCertificateHint: "A letter stating your salary, for a bank or an embassy.",
    certificateHowItWorks: "What happens next",
    certificateNote: "HR is told straight away. They produce the certificate themselves and give it to you — approving the request does not create the document, so you will hear from them rather than find it appear.",
    certificateReason: "What is it for? (optional)",
    title: "Requests",
    newRequest: "What would you like to ask for?",
    myRequests: "My requests",
    myLeave: "My leave requests",
    leaveWaitingOnMe: "Leave waiting on your decision",
    decideOnLeavePage: "Open the leave screen to decide",
    waitingOnMe: "Waiting on me",
    none: "You have not made any requests yet.",
    kind: "Request",
    detail: "Details",
    decidedBy: "Decided by",
    submit: "Submit request",
    withdraw: "Withdraw",
    approve: "Approve",
    reject: "Reject",

    kindLeave: "Leave",
    kindLeaveHint: "Annual, sick, emergency and other leave.",
    kindLateArrival: "Late arrival",
    kindLateArrivalHint: "Tell your manager in advance that you will be late.",
    kindCorrection: "Attendance correction",
    kindCorrectionHint: "A missing or incorrect clock-in or clock-out.",
    kindAdvance: "Salary advance",
    kindAdvanceHint: "Ask for an advance, repaid from your salary.",

    statusPending: "Waiting",
    statusApproved: "Approved",
    statusRejected: "Rejected",
    statusCancelled: "Withdrawn",

    actualCheckIn: "Actual arrival time",
    actualCheckOut: "Actual leaving time",
    actualTimesHint: "Fill in whichever you know. If your manager accepts the correction these become the day's real times, so the hours are calculated rather than estimated. Leave both empty if only the status is wrong.",
    workDate: "Which day",
    expectedArrival: "What time you expect to arrive",
    lateArrivalNote:
      "This must be sent at least two hours before your shift starts, so cover can be arranged. If it is approved, the day will not be counted as late.",

    shouldBe: "What the day should say",
    pickADay: "Choose a day…",
    dayNoRecord: "nothing recorded",
    nothingToCorrect: "No day in the last sixty days needs correcting — every day is recorded and complete.",
    correctionNote:
      "Only days that look wrong are listed. Your manager approves the correction and the record is updated for you.",
    correctionReasonHint: "For example: I was here until 17:30 but forgot to clock out.",
    statusWasPresent: "I was here",
    statusWasLate: "I was here, but late",
    statusWasOnLeave: "I was on approved leave",
    statusWasAbsent: "I was not here",

    amount: "How much you need",
    monthlyDeduction: "How much to deduct each month",
    reasonOptional: "Reason (optional)",
    advanceHowItWorks: "How an advance is repaid",
    advancePoint1: "The approved amount is recovered from your salary, by a deduction each month until it is repaid in full.",
    advancePoint2: "The monthly deduction you enter below is your preferred proposal.",
    advancePoint3: "HR will review the request and may approve a different monthly deduction and repayment schedule.",
    proposalOnly: "The monthly deduction amount you enter is only your preferred proposal. HR will review the request and may approve a different monthly deduction amount and repayment schedule.",
    advancePrivacy: "Seen only by HR. Your manager is not shown this request.",
  },
  ar: {
    kindBug: "الإبلاغ عن مشكلة",
    kindBugHint: "شيء في النظام لم يعمل. يصل البلاغ إلى مسؤول النظام.",
    bugPlaceholder: "ماذا حدث؟ اكتبها بالطريقة التي تناسبك.",
    bugCaptured: "تُرفَق الصفحة التي كنت فيها وهويتك والوقت تلقائياً — لا حاجة لذكرها.",
    bugWhatHappened: "ماذا حدث؟",
    bugWhatHappenedHint: "ما الذي كنت تفعله، وما الذي فعله النظام بدلاً من ذلك. أي تفاصيل تتذكرها تساعد.",
    bugWhereLabel: "أين حدثت المشكلة",
    bugWhereNote: "مأخوذ من الشاشة التي كنت فيها عند فتح هذا النموذج، ويُرسل مع البلاغ ليسهل تتبع المشكلة.",
    bugStatusOpen: "مفتوح",
    bugStatusFixed: "تم الإصلاح",
    bugStatusWontFix: "ليست مشكلة",
    bugStatusWithdrawn: "مسحوب",
    kindCertificate: "شهادة راتب",
    kindCertificateHint: "خطاب يوضح راتبك، للبنك أو للسفارة.",
    certificateHowItWorks: "ماذا يحدث بعد ذلك",
    certificateNote: "يصل الطلب إلى الموارد البشرية فوراً. هم من يصدر الشهادة ويسلمها لك — اعتماد الطلب لا ينشئ المستند، لذا ستصلك منهم ولن تظهر تلقائياً.",
    certificateReason: "ما الغرض منها؟ (اختياري)",
    title: "الطلبات",
    newRequest: "ما الذي تود طلبه؟",
    myRequests: "طلباتي",
    myLeave: "طلبات الإجازة",
    leaveWaitingOnMe: "إجازات بانتظار قرارك",
    decideOnLeavePage: "افتح شاشة الإجازات للبت فيها",
    waitingOnMe: "بانتظار قراري",
    none: "لم تقدّم أي طلب بعد.",
    kind: "الطلب",
    detail: "التفاصيل",
    decidedBy: "صاحب القرار",
    submit: "إرسال الطلب",
    withdraw: "سحب الطلب",
    approve: "اعتماد",
    reject: "رفض",

    kindLeave: "إجازة",
    kindLeaveHint: "سنوية، مرضية، اضطرارية وغيرها.",
    kindLateArrival: "تأخير عن الدوام",
    kindLateArrivalHint: "إبلاغ مديرك مسبقاً بأنك ستتأخر.",
    kindCorrection: "تصحيح سجل الحضور",
    kindCorrectionHint: "بصمة دخول أو خروج ناقصة أو غير صحيحة.",
    kindAdvance: "سلفة على الراتب",
    kindAdvanceHint: "طلب سلفة تُسدَّد من الراتب.",

    statusPending: "قيد الانتظار",
    statusApproved: "معتمد",
    statusRejected: "مرفوض",
    statusCancelled: "مسحوب",

    actualCheckIn: "وقت الحضور الفعلي",
    actualCheckOut: "وقت الانصراف الفعلي",
    actualTimesHint: "أدخل ما تعرفه منهما. إذا اعتمد مديرك التصحيح تصبح هذه أوقات اليوم الفعلية، فتُحتسب الساعات بدل تقديرها. اترك الحقلين فارغين إذا كانت الحالة فقط هي الخطأ.",
    workDate: "اليوم",
    expectedArrival: "وقت الوصول المتوقع",
    lateArrivalNote:
      "يجب إرسال الطلب قبل ساعتين على الأقل من بداية الدوام حتى يُرتَّب البديل. وعند الاعتماد لا يُحتسب اليوم تأخيراً.",

    shouldBe: "ما يجب أن يكون عليه اليوم",
    pickADay: "اختر يوماً…",
    dayNoRecord: "لا يوجد تسجيل",
    nothingToCorrect: "ما في يوم يحتاج تصحيحاً خلال الستين يوماً الماضية — كل يوم مسجَّل ومكتمل.",
    correctionNote:
      "تُعرض الأيام التي تبدو غير صحيحة فقط. يعتمد مديرك التصحيح ويُحدَّث السجل تلقائياً.",
    correctionReasonHint: "مثال: كنت موجوداً حتى الساعة 17:30 لكنني نسيت تسجيل الانصراف.",
    statusWasPresent: "كنت حاضراً",
    statusWasLate: "كنت حاضراً لكن متأخراً",
    statusWasOnLeave: "كنت في إجازة معتمدة",
    statusWasAbsent: "لم أكن حاضراً",

    amount: "المبلغ المطلوب",
    monthlyDeduction: "مبلغ الخصم الشهري",
    reasonOptional: "السبب (اختياري)",
    advanceHowItWorks: "كيف تُسدَّد السلفة",
    advancePoint1: "يُسترد المبلغ المعتمد من راتبك عن طريق خصم شهري حتى السداد الكامل.",
    advancePoint2: "مبلغ الخصم الشهري الذي تدخله أدناه هو اقتراحك المفضّل فقط.",
    advancePoint3: "ستراجع الموارد البشرية الطلب وقد تعتمد مبلغ خصم شهري وجدول سداد مختلفين.",
    proposalOnly: "مبلغ الخصم الشهري الذي تدخله هو اقتراحك المفضّل فقط. ستراجع الموارد البشرية الطلب وقد تعتمد مبلغ خصم شهري وجدول سداد مختلفين.",
    advancePrivacy: "يطّلع عليه قسم الموارد البشرية فقط، ولا يظهر لمديرك المباشر.",
  },
} as const;
